import type * as React from 'react';
import styles from './style.m.less';

export const Container: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <div className={styles.container}>{children}</div>;
};
